import { type RootState } from "../../redux/store";

export const selectProductComparisonList = (state: RootState) => state.productComparison.comparisonList;
